import { loadQuery } from 'react-relay';
import RelayEnvironment from 'lib/utils/relay';
import { getAccountId, getUserId } from 'lib/utils/authentication';
import { ACCOUNT_QUERY } from 'services/account/account.relay.services';
import { accountQuery } from 'services/account/__generated__/accountQuery.graphql';
import { userProfileQuery } from 'services/user/__generated__/userProfileQuery.graphql';
import { USER_PROFILE_QUERY } from 'services/user/user.relay.services';

export const SettingsIntegrationsPreloadData = Props => {
  const accountId = getAccountId() ?? '';
  return {
    accountQueryRef: loadQuery<accountQuery>(
      RelayEnvironment,
      ACCOUNT_QUERY,
      {
        id: accountId,
      },
      { fetchPolicy: 'store-or-network' },
    ),
    userProfileQueryRef: loadQuery<userProfileQuery>(RelayEnvironment, USER_PROFILE_QUERY, {
      id: getUserId(),
      skip: false,
    }),
  };
};

export type SettingsIntegrationsPreloadDataType = ReturnType<typeof SettingsIntegrationsPreloadData>;
